module.exports = __webpack_public_path__ + "static/img/fullscreen-image_or-add-your-own_600.192df81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-manual-wizard/fullscreen-image_or-add-your-own_600.png
// module id = yrgn
// module chunks = 0